module.exports = __webpack_public_path__ + "static/media/Default Effect - ben-3-Rp9xLMI6k-unsplash.f465b60f.jpg";